module.exports = __webpack_public_path__ + "img/c2.660c2295.jpg";